import React from 'react'

function TechSelectionSKS() {
  return (
    <embed src="\pdfs\E2.1.2_SKS-5-3_Static_cooling_ceiling_system_01.2010_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionSKS